import { useState } from "react";
import { NavLink } from "react-router-dom";

export default function Sidebar() {
  const [openSection, setOpenSection] = useState(0); // first open by default
  const [mobileOpen, setMobileOpen] = useState(false);

  const sidebar = [
    {
      title: "Introduction",
      items: [
        { label: "Overview", path: "/docs/overview" },
        { label: "System Architecture", path: "/docs/system-architecture" },
        { label: "Tech Stack", path: "/docs/tech-stack" },
        { label: "Who Is This For?", path: "/docs/who-is-this-for" },
      ],
    },
    {
      title: "Getting Started",
      items: [
        { label: "Quick Start", path: "/docs/quick-start" },
        { label: "Installation", path: "/docs/installation" },
        { label: "Initial Setup", path: "/docs/initial-setup" },
        { label: "First Event Booking", path: "/docs/first-event-booking" },
      ],
    },
    {
      title: "Core Features",
      items: [
        { label: "Dashboard", path: "/docs/admin-dashboard" },
        { label: "Event Booking Management", path: "/docs/event-booking-management" },
        { label: "Reports Module", path: "/docs/reports" },
        { label: "Banquet Setup Module", path: "/docs/banquet-setup" },
        // { label: "Online Reservations Module", path: "/docs/online-reservations" },
        { label: "Expense Module", path: "/docs/expenses" },
        { label: "Procurement Module", path: "/docs/Procurement" },
        { label: "Accounting Module", path: "/docs/accounting" },
        { label: "Access Control Module", path: "/docs/access-control" },
        // { label: "Receipt & Payment Management", path: "/docs/payments" },
      ],
    },
    {
      title: "Business Solutions",
      items: [
        { label: "Eliminate Manual Registers", path: "/docs/no-registers" },
        { label: "Prevent Double Bookings", path: "/docs/no-double-booking" },
        { label: "Real-time Financial Insights", path: "/docs/financial-insights" },
        { label: "Multi-user Access Control", path: "/docs/access-control-bi" },
        { label: "Organized Record Keeping", path: "/docs/records" },
        { label: "Staff Efficiency", path: "/docs/staff-efficiency" },
      ],
    },
    // {
    //   title: "Pricing",
    //   items: [
    //     { label: "Plans", path: "/docs/plans" },
    //     { label: "Feature Comparison", path: "/docs/feature-comparison" },
    //     { label: "FAQs", path: "/docs/pricing-faqs" },
    //   ],
    // },
    {
      title: "Services",
      items: [
        { label: "Customization", path: "/docs/customization" },
        { label: "Integration", path: "/docs/integration" },
        { label: "Data Migration", path: "/docs/data-migration" },
        // { label: "Training & Support", path: "/docs/training-support" },
      ],
    },
    {
      title: "Resources",
      items: [
        { label: "About Us", path: "/docs/about" },
        { label: "Support", path: "/docs/support" },
        { label: "Contact Us", path: "/docs/contact" },
        { label: "FAQs", path: "/docs/faqs" },
      ],
    },
  ];

  const SidebarContent = (
    <aside className="w-80 h-[calc(100vh-64px)] border-r border-slate-200 overflow-y-auto">
      <div className="px-4 py-5 text-md">
        {sidebar.map((section, index) => {
          const isOpen = openSection === index;

          return (
            <div key={index} className="mb-4">
              <button
                onClick={() => setOpenSection(isOpen ? null : index)}
                className="w-full mt-6 flex items-center justify-between text-slate-700 font-semibold hover:text-[#C9A24E]"
              >
                {section.title}
                <i
                  className={`fa-solid ${
                    isOpen ? "fa-chevron-up" : "fa-chevron-down"
                  } text-xs`}
                />
              </button>

              {isOpen && (
                <ul className="mt-2 ml-2 border-l border-slate-200 text-sm">
                  {section.items.map((item, i) => (
                    <li key={i}>
                      <NavLink
                        to={item.path}
                        onClick={() => setMobileOpen(false)}
                        className={({ isActive }) =>
                          `block pl-4 py-1.5 rounded-r-md transition
                          ${
                            isActive
                              ? "text-[#C9A24E] bg-[#C9A24E]/5 font-medium"
                              : "text-slate-600 hover:text-[#C9A24E]"
                          }`
                        }
                      >
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );

  return (
    <>
      {/* MOBILE HAMBURGER (ONLY RESPONSIVE ADDITION) */}
      <button
        onClick={() => setMobileOpen(true)}
        className="lg:hidden fixed top-20 left-4 z-40 bg-white border border-slate-200 rounded-md px-3 py-2 shadow"
      >
        ☰
      </button>

      {/* DESKTOP SIDEBAR (UNCHANGED) */}
      <div className="hidden lg:block sticky top-16">
        {SidebarContent}
      </div>

      {/* MOBILE OVERLAY */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* MOBILE DRAWER */}
      <div
        className={`fixed top-0 left-0 z-50 h-full w-80 bg-white transform transition-transform duration-300 lg:hidden
        ${mobileOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {SidebarContent}
      </div>
    </>
  );
}
